import { useEffect, useRef } from "react";
import { useMediaQuery } from "@mui/material";

import { useTypedTheme } from "hooks";

import { SummaryWrapper } from "./components/SummaryWrapper";

type Props = {
  oneSeatAllowed?: boolean;
  page6Variant?: boolean;
  plugForFirstStep?: boolean;
  notshowOnMobile?: boolean;
  sectionBoxHeight?: number;
};
const Summary = ({
  page6Variant = false,
  sectionBoxHeight,
  plugForFirstStep = false,
  notshowOnMobile = false,
}: Props) => {
  // styles
  const {
    theme: {
      breakpoints: { down },
    },
  } = useTypedTheme();
  const matches = useMediaQuery(down("md"));
  // state
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current !== null) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  });

  if (matches && notshowOnMobile) return null;

  if (matches && !page6Variant) return <></>;

  return (
    <SummaryWrapper
      sectionBoxHeight={sectionBoxHeight}
      plugForFirstStep={plugForFirstStep}
      page6Variant={page6Variant}
    />
  );
};

export default Summary;
